import { Box, Button, Tab, Tabs, Typography } from '@mui/material'
import { SyntheticEvent, useContext, useState } from 'react'
import AreaQuickSelect from './AreaQuickSelect'
import MaterialQuickSelect from './MaterialQuickSelect'
import { ExportIcon } from '../../Svgs'
import { AbilityContext, Can } from '../../../utils/AbilityUtil'
import {
  AttributeActionNames,
  AttributeResourceNames,
} from '../../../models/AccessControl'

enum QuickSelectTab {
  Area = 'Area',
  Material = 'Material',
}

const QuickSelect = () => {
  const [selectedTab, setSelectedTab] = useState<QuickSelectTab>(
    QuickSelectTab.Area,
  )

  const handleTabChange = (event: SyntheticEvent, newValue: QuickSelectTab) => {
    setSelectedTab(newValue)
  }

  const handleExportFullTakeOffClick = async () => {
    try {
      const response = await fetch('assets/takeoff.xlsx')
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Takeoff Ross - No Labor.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url) // Clean up the URL object
    } catch (error) {
      console.error('Error downloading the file:', error)
    }
  }

  const ability = useContext(AbilityContext)

  return (
    <Box
      sx={{
        backgroundColor: '#F2F2F2',
        borderRadius: '4px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Can I={AttributeActionNames.Read} a={AttributeResourceNames.TakeOff}>
        <Tabs
          value={selectedTab}
          variant='fullWidth'
          onChange={handleTabChange}
          aria-label='quick-select-tabs'
          sx={{
            borderRadius: '4px 4px 0px 0px',
            '& .MuiTabs-indicator': {
              display: 'none',
            },
          }}
        >
          {Object.keys(QuickSelectTab).map((value) => (
            <Tab
              key={value}
              value={value}
              label={`${value} Select`}
              disableRipple
              disabled={value === QuickSelectTab.Material}
              id={`quick-select-tab-${value.toLowerCase()}`}
              aria-controls={`quick-select-tab-${value.toLowerCase()}`}
              sx={{
                color: '#858585',
                textAlign: 'center',

                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
                textTransform: 'none',
                backgroundColor: '#D1D1D1',
                '&.Mui-selected': {
                  color: '#04002E',
                  backgroundColor: '#F2F2F2',
                },
              }}
            />
          ))}
        </Tabs>

        <Box
          sx={{
            paddingLeft: '16px',
            paddingTop: '20px',
            overflow: 'hidden',
            flexGrow: 1,
          }}
        >
          {selectedTab === QuickSelectTab.Area && <AreaQuickSelect />}

          {selectedTab === QuickSelectTab.Material && <MaterialQuickSelect />}
        </Box>

        <Box sx={{ padding: '16px' }}>
          <Button
            disabled={ability.cannot(
              AttributeActionNames.Manage,
              AttributeResourceNames.TakeOff,
            )}
            fullWidth
            disableElevation
            variant='contained'
            onClick={handleExportFullTakeOffClick}
            sx={{
              height: 42,
              borderRadius: '4px',
              background: '#06004A',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '14px',
              }}
            >
              <ExportIcon sx={{ color: 'white', fontSize: 14 }} />

              <Typography
                sx={{
                  color: '#FFF',
                  textAlign: 'center',

                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  lineHeight: 'normal',
                  textTransform: 'none',
                }}
              >
                Export Full Takeoff
              </Typography>
            </Box>
          </Button>
        </Box>
      </Can>
    </Box>
  )
}

export default QuickSelect
